import { PeriodEnum } from './tradingViewSimpleChart.props.js';
import { getLang } from '../../utils/langs.utils.js';
import { formateHasIntraDay } from './tradingViewSimpleChart.utils.js';

const periodsWithTime = [
    PeriodEnum.day,
    PeriodEnum.week,
    PeriodEnum.month,
];
const histogramScale = {
    scaleMargins: {
        top: 0.45,
        bottom: 0,
    },
};
const linearScale = {
    scaleMargins: {
        top: 0.1,
        bottom: 0.2,
    },
};
const colors = {
    light: {
        actionDefault: '#ff9b63',
        backgroundPrimary: '#f8f8f8',
        backgroundSecondary: '#ffffff',
        strokeNeutralSoftInitial: '#d7d8da',
        positive: '#2DA08D',
        negative: '#FD677A',
        labelPrimary: '#242631',
    },
    dark: {
        actionDefault: '#ff9b63',
        backgroundPrimary: '#242631',
        backgroundSecondary: '#303341',
        strokeNeutralSoftInitial: '#595b67',
        positive: '#89F7C4',
        negative: '#FE8589',
        labelPrimary: '#242631',
        labelBackground: '#FFFFFF',
    },
};
const chartStyles = (theme, selectedPeriod) => {
    return {
        histogram: {
            base: 0,
            color: colors[theme].strokeNeutralSoftInitial,
            priceScaleId: '',
            lastValueVisible: false,
            visible: false,
        },
        lineSeries: {
            color: colors[theme].actionDefault,
            lineWidth: 2,
            crosshairMarkerRadius: 3,
            crosshairMarkerBorderColor: colors[theme].actionDefault,
            crosshairMarkerBackgroundColor: colors[theme].labelBackground,
            visible: false,
        },
        candleSeries: {
            wickUpColor: colors[theme].positive,
            upColor: colors[theme].positive,
            wickDownColor: colors[theme].negative,
            downColor: colors[theme].negative,
            wickColor: colors[theme].labelBackground,
            visible: false,
        },
        chart: {
            localization: {
                locale: getLang(),
                timeFormatter: (time) => {
                    const hasIntraDay = selectedPeriod === PeriodEnum.day;
                    return formateHasIntraDay(time, hasIntraDay);
                },
                priceFormatter: (price) => {
                    return price.toFixed(2).replace('.', ',');
                },
            },
            rightPriceScale: {
                borderVisible: false,
            },
            layout: {
                background: { color: colors[theme].backgroundPrimary },
                textColor: colors[theme].labelBackground,
            },
            grid: {
                vertLines: {
                    color: 'transparent',
                },
                horzLines: {
                    color: 'transparent',
                },
            },
            timeScale: {
                timeVisible: true,
                secondsVisible: false,
                borderVisible: false,
                fixLeftEdge: true,
                fixRightEdge: true,
                tickMarkFormatter: (time) => {
                    const hasIntraDay = selectedPeriod === PeriodEnum.day;
                    return formateHasIntraDay(time, hasIntraDay, true);
                },
            },
            crosshair: {
                vertLine: {
                    width: 1,
                    style: 4,
                    color: colors[theme].labelBackground,
                    labelBackgroundColor: colors[theme].strokeNeutralSoftInitial,
                },
                horzLine: {
                    width: 1,
                    style: 4,
                    color: colors[theme].labelBackground,
                    labelBackgroundColor: colors[theme].strokeNeutralSoftInitial,
                },
            },
        },
    };
};

export { chartStyles, histogramScale, linearScale, periodsWithTime };
//# sourceMappingURL=tradingViewSimpleChart.customization.js.map
